import { render } from "./NewTicketSecondaryTitle.vue?vue&type=template&id=286058e5"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "286058e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('286058e5', script)) {
    api.reload('286058e5', script)
  }
  
  module.hot.accept("./NewTicketSecondaryTitle.vue?vue&type=template&id=286058e5", () => {
    api.rerender('286058e5', render)
  })

}

script.__file = "src/views/support/pageTitles/NewTicketSecondaryTitle.vue"

export default script